import { UserCourse } from "../../models/interfaces/user-course.interface";
import { courseMock } from "./course.mock";

const USER_ID = '1c41afca-e637-4d9f-8cd1-2b3f3302f80d';
const DATE_2026_01_30 = '2026-01-30';
const DATE_2026_02_15 = '2026-02-15';
const DATE_2026_02_20 = '2026-02-20';

export const userCourseMock: UserCourse[] = [
  {
    id: 'user-course-1',
    userId: USER_ID,
    courseId: 'course-uuid-1',
    progress: 10,
    startedAt: new Date('2026-02-01'),
    lastAccessedAt: new Date('2026-03-05'),
    course: courseMock[0],
    createdAt: new Date('2026-02-01'),
    updatedAt: new Date('2026-03-05'),
    isActive: true,
  },
  {
    id: 'user-course-2',
    userId: USER_ID,
    courseId: 'course-uuid-2',
    progress: 0,
    course: courseMock[1],
    createdAt: new Date(DATE_2026_02_15),
    updatedAt: new Date(DATE_2026_02_15),
    isActive: true,
  },
  {
    id: 'user-course-3',
    userId: USER_ID,
    courseId: 'course-uuid-3',
    progress: 100,
    startedAt: new Date('2026-01-01'),
    completedAt: new Date(DATE_2026_01_30),
    lastAccessedAt: new Date(DATE_2026_01_30),
    course: courseMock[2],
    createdAt: new Date('2026-01-01'),
    updatedAt: new Date(DATE_2026_01_30),
    isActive: true,
  },
  {
    id: 'user-course-4',
    userId: USER_ID,
    courseId: 'course-uuid-4',
    progress: 45,
    startedAt: new Date('2026-02-10'),
    lastAccessedAt: new Date('2026-03-08'),
    course: courseMock[3],
    createdAt: new Date('2026-02-10'),
    updatedAt: new Date('2026-03-08'),
    isActive: true,
  },
  {
    id: 'user-course-5',
    userId: USER_ID,
    courseId: 'course-uuid-5',
    progress: 0,
    course: courseMock[4],
    createdAt: new Date('2026-03-01'),
    updatedAt: new Date('2026-03-01'),
    isActive: true,
  },
  {
    id: 'user-course-6',
    userId: USER_ID,
    courseId: 'course-uuid-6',
    progress: 100,
    startedAt: new Date('2026-01-15'),
    completedAt: new Date(DATE_2026_02_20),
    lastAccessedAt: new Date(DATE_2026_02_20),
    course: courseMock[5],
    createdAt: new Date('2026-01-15'),
    updatedAt: new Date(DATE_2026_02_20),
    isActive: true,
  },
  {
    id: 'user-course-7',
    userId: USER_ID,
    courseId: 'course-uuid-7',
    progress: 75,
    startedAt: new Date(DATE_2026_02_20),
    lastAccessedAt: new Date('2026-03-09'),
    course: courseMock[6],
    createdAt: new Date(DATE_2026_02_20),
    updatedAt: new Date('2026-03-09'),
    isActive: true,
  },
  {
    id: 'user-course-po',
    userId: USER_ID,
    courseId: 'course-uuid-po',
    progress: 0,
    course: courseMock.find((course) => course.id === 'course-uuid-po')!,
    createdAt: new Date(DATE_2026_02_15),
    updatedAt: new Date(DATE_2026_02_15),
    isActive: true,
  },
];
